module.exports = __webpack_public_path__ + "img/paint-strip-white-up.e01b78a.png";